import React, { useState, useEffect } from "react";
import RequestsMerchantTable from "./components/RequestsMerchantTable";
import Divider from "@material-ui/core/Divider";
import axios from "axios";
import { v4 as uuid } from "uuid";

export default function RequestsMerchant() {
  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);

 

  const onWishLists = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}apply?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
        ).catch((error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        });
  };


  const onUpdateWishListStatus = (id, statusType) => {
    let status = !statusType;
    axios
      .put(
        `${process.env.REACT_APP_API_URL}wishList/updateStatus`,
        {
          id,
          status,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onWishLists(skip, take, sortField, orderBy);
      });
  };


  useEffect(() => {
    onWishLists(skip, take, sortField, orderBy);
  }, [skip, take, sortField, orderBy]);

  const onWishListsExport = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}wishList/export`, {
        responseType: "blob",
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "WishLists.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Requests by Merchant</h1>
        {/* <FormControlLabel
          control={
            <Switch
              // checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        /> */}
      </div>
      <Divider className="w-100" />
      <RequestsMerchantTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateWishListStatus={onUpdateWishListStatus}
        onWishListsExport={onWishListsExport}
      />
    </div>
  );
}
